import React from 'react';
import { motion } from 'framer-motion';

export const BryButton = ({
  children,
  variant = 'primary', // primary | secondary | ghost | danger
  size = 'md', // sm | md | lg
  icon: Icon,
  iconPosition = 'left',
  isIconOnly = false,
  isLoading = false,
  disabled = false,
  className = '',
  onClick,
  type = 'button',
  ...props
}) => {
  const variantClass = `bry-btn-${variant}`;
  const sizeClass = size !== 'md' ? `bry-btn-${size}` : '';
  const iconOnlyClass = isIconOnly ? 'bry-btn-icon-only' : '';
  const combinedClasses = `bry-btn ${variantClass} ${sizeClass} ${iconOnlyClass} ${className}`.trim();

  return (
    <motion.button
      type={type}
      whileTap={{ scale: disabled || isLoading ? 1 : 0.97 }}
      whileHover={{ scale: disabled || isLoading ? 1 : 1.02 }}
      className={combinedClasses}
      onClick={onClick}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
      ) : (
        <>
          {Icon && iconPosition === 'left' && <Icon className="bry-btn-icon" />}
          {!isIconOnly && children}
          {Icon && iconPosition === 'right' && <Icon className="bry-btn-icon" />}
        </>
      )}
    </motion.button>
  );
};
